import React from "react";

export const CategoryTitle: React.FC<{
  title: string;
  subtitle?: string | undefined | null;
  className?: string;
}> = ({ title, subtitle, className }) => {
  const classes = ["category-title font-xxl mb-15", className]
    .filter(c => !!c)
    .join(" ");
  return (
    <div className={classes}>
      <span className="font-bold">{title}</span>
      {subtitle && (
        <>
          <span className="font-light separator">|</span>
          <span className="font-light">{subtitle}</span>
        </>
      )}
    </div>
  );
};
